import { Box, FormLabel, Slider as MuiSlider, Typography } from '@mui/material';
import React from 'react';

export interface SliderOption {
  value: number;
  label: string;
}

interface SliderProps {
  field: any;
  name: string;
  label: string;
  helperText?: string;
  required?: boolean;
  min?: number;
  max?: number;
  step?: number;
  leftLabel?: string;
  middleLabel?: string;
  rightLabel?: string;
}

export const Slider: React.FC<SliderProps> = ({
  field,
  name,
  label,
  helperText,
  required,
  min = 0,
  max = 10,
  step = 1,
  leftLabel,
  middleLabel,
  rightLabel
}) => {
  const middleValue = Math.floor((min + max) / 2);

  return (
    <Box sx={{ width: '100%' }}>
      <FormLabel component="legend" required={required}>
        {label}
      </FormLabel>

      <Box sx={{ mt: 2, mb: 1, px: 1 }}>
        <MuiSlider
          value={field.state.value}
          onChange={(_, value) => field.handleChange(value)}
          min={min}
          max={max}
          step={step}
          valueLabelDisplay="off"
          sx={{ mb: 2 }}
        />

        {/* Labels below the slider */}
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          {leftLabel && (
            <Typography variant="caption" color="text.secondary" sx={{ textAlign: 'left', flex: 1 }}>
              {leftLabel}
            </Typography>
          )}
          {middleLabel && (
            <Typography variant="caption" color="text.secondary" sx={{ textAlign: 'center', flex: 1 }}>
              {middleLabel}
            </Typography>
          )}
          {rightLabel && (
            <Typography variant="caption" color="text.secondary" sx={{ textAlign: 'right', flex: 1 }}>
              {rightLabel}
            </Typography>
          )}
        </Box>
      </Box>

      {helperText && (
        <Typography variant="caption" color="text.secondary">
          {helperText}
        </Typography>
      )}
    </Box>
  );
}; 